export default [
  {
    text: "admin",
    value: "1",
  },
  {
    text: "Emily",
    value: "3",
  },
  {
    text: "Beer",
    value: "5",
  },
  {
    text: "Paul",
    value: "6",
  },

  {
    text: "MING",
    value: "16",
  },
  {
    text: "NICK",
    value: "17",
  },
  {
    text: "BAOLAI",
    value: "18",
  },
  {
    text: "Feng",
    value: "19",
  },
  // {
  //   text: "Theo",
  //   value: "21",
  // },
  {
    text: "Daisy",
    value: "23",
  },
  {
    text: "James",
    value: "24",
  },
];
